import { otherLanguages } from 'i18n/constants';
import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';
export type SeoProps = {
  path?: string;
  title?: string;
  description?: string;
  noindex?: boolean;
  nofollow?: boolean;
  generateAlternateUrls?: boolean;
  supportedLanguages?: string[];
  images?: {
    url: string;
    width: number;
    height: number;
    alt?: string;
  }[];
};
export default function Seo({
  path = '/',
  title = '',
  description = '',
  noindex = false,
  nofollow = false,
  generateAlternateUrls = true,
  supportedLanguages = otherLanguages,
  images
}: SeoProps) {
  const router = useRouter();
  const host = process.env.NEXT_PUBLIC_CANONICAL_URL;
  const normalizedPath = path.length >= 1 && path.endsWith('/') ? path.slice(0, -1) : path;
  const mainUrl = new URL(normalizedPath === '' ? '/' : normalizedPath, host).toString();
  const alternateUrls = [{
    hrefLang: 'en',
    href: mainUrl
  }];
  const otherLangUrls = supportedLanguages.filter(lang => lang !== 'en').map(lang => ({
    hrefLang: lang,
    href: new URL(`/${lang}${normalizedPath}`, host).toString()
  }));
  alternateUrls.push(...otherLangUrls);
  const locale = router.query.locale as string;
  const canonical = alternateUrls.find(alt => alt.hrefLang === (supportedLanguages.includes(locale) ? locale : 'en'));
  const shouldNoIndex = process.env.NEXT_PUBLIC_NO_INDEX === 'true' || locale !== 'en' && !supportedLanguages.includes(locale);
  return <NextSeo title={title} description={description} canonical={canonical?.href} openGraph={{
    title,
    description,
    images,
    locale,
    type: 'website',
    siteName: 'Todoist'
  }} noindex={noindex || shouldNoIndex} nofollow={nofollow || shouldNoIndex} languageAlternates={generateAlternateUrls ? alternateUrls : undefined} data-sentry-element="NextSeo" data-sentry-component="Seo" data-sentry-source-file="Seo.tsx" />;
}